function asNullIfOtherFieldIsNotTrue(otherFieldName) {
    return (cellParams) => {
        return !cellParams.data[otherFieldName] ? cellParams.data[cellParams.colDef.field] : null
    }
}

function asNullIfOtherFieldIsTrue(otherFieldName) {
    return (cellParams) => {
        return cellParams.data[otherFieldName] ? cellParams.data[cellParams.colDef.field] : null
    }
}

export {
    asNullIfOtherFieldIsNotTrue,
    asNullIfOtherFieldIsTrue
};